// extracted by mini-css-extract-plugin
export var container = "terms-module--container--2XmuP";
export var main = "terms-module--main--1n8cp";
export var mainRaised = "terms-module--mainRaised--2gZjD";
export var section = "terms-module--section--2IZxS";
export var header = "terms-module--header--3ld9M";
export var statement = "terms-module--statement--hT5KN";
export var blueBanner = "terms-module--blueBanner--1d2YO";
export var space150 = "terms-module--space150--3yQOL";
export var mainPadding = "terms-module--mainPadding--UMYCT";